import script from "./AccountFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountFormView.vue?vue&type=script&setup=true&lang=js"

import "./AccountFormView.vue?vue&type=style&index=0&id=56ba30fb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56ba30fb"]])

export default __exports__